import React from 'react';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
// ToggleButton Component
const useToggleButtonStyles = makeStyles((theme) => ({
  root: {
    textTransform: 'none',
    border: `1px solid ${theme.palette.divider}`,
    padding: '6px 16px',
    '&:not(:first-child)': {
      borderLeft: 'none',
      marginLeft: 0,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    transition: theme.transitions.create(['background-color', 'border-color'], {
      duration: theme.transitions.duration.short,
    }),
  },
  selected: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  disabled: {
    opacity: 0.5,
  },
}));

export const ToggleButton = React.forwardRef(({
  value,
  selected = false,
  disabled = false,
  children,
  onChange,
  className,
  ...props
}, ref) => {
  const classes = useToggleButtonStyles();

  const handleClick = (event) => {
    if (!disabled && onChange) {
      onChange(event, value);
    }
  };

  return (
    <Button
      ref={ref}
      className={clsx(
        classes.root,
        {
          [classes.selected]: selected,
          [classes.disabled]: disabled,
        },
        className
      )}
      disabled={disabled}
      onClick={handleClick}
      {...props}
    >
      {children}
    </Button>
  );
});
